import { useFormEvents } from '@lib/common';
import { Button } from '@material-ui/core';
import { InvoiceRunForms, InvoiceRunStatus } from 'app/state';
import React, { useCallback, useEffect } from 'react';
import { InvoiceRunGenerateModal } from './invoice-run-generate-modal';
import { InvoiceRunGeneratingModal } from './invoice-run-generating-modal';
import { CommonForm } from '@lib/state';

interface Props {
  draft: boolean;
  exportGenerated: boolean;
  generatingExport: boolean;
  onGenerateExport: () => void;
  onDownloadExport: () => void;
  runStatus: InvoiceRunStatus | undefined;
}

export function InvoiceRunDownloadButton({
  draft,
  exportGenerated,
  generatingExport,
  onDownloadExport,
  onGenerateExport,
  runStatus,
}: Props) {
  const [generateExportModalOpen, setGenerateExportModalOpen] = React.useState(false);
  const [exportingModalOpen, setExportingModalOpen] = React.useState(false);

  const [formEvents] = useFormEvents(InvoiceRunForms.GenerateExport);
  const [exportEvents] = useFormEvents(CommonForm.Export);

  const onButtonClick = useCallback(() => {
    if (!exportGenerated && !generatingExport) {
      setGenerateExportModalOpen(true);
      return;
    } else if (!exportGenerated && generatingExport) {
      setExportingModalOpen(true);
      return;
    }
    onDownloadExport();
  }, [exportGenerated, generatingExport, onDownloadExport]);

  const onGenerateExportConfirm = useCallback(() => {
    onGenerateExport();
    setGenerateExportModalOpen(false);
  }, [onGenerateExport, setGenerateExportModalOpen]);

  useEffect(() => {
    if (exportEvents.status === 'error') {
      setGenerateExportModalOpen(true);
    }
  }, [exportEvents.status]);

  return (
    <>
      <InvoiceRunGenerateModal
        open={generateExportModalOpen}
        draft={draft}
        onClose={() => setGenerateExportModalOpen(false)}
        onConfirm={onGenerateExportConfirm}
        status={exportEvents.status}
        disable
      />
      <InvoiceRunGeneratingModal
        open={exportingModalOpen}
        onClose={() => setExportingModalOpen(false)}
      />
      <Button
        type="button"
        variant="contained"
        color="primary"
        onClick={onButtonClick}
        disabled={
          exportEvents.status === 'pending' ||
          formEvents.status === 'pending' ||
          runStatus !== InvoiceRunStatus.Complete
        }
      >
        Download Invoices
      </Button>
    </>
  );
}
